import React from "react";
import { Navigate } from "react-router-dom";

/** Legacy entry: redirect to Blast by Status (loads only that cohort). */
const CallBlasting = () => <Navigate to="/call-blasting/status" replace />;

export default CallBlasting;
